export default{
    title: "Client plataform",
    welcome: "Welcome",
    acsess: 'Access my account',
    passowrd: 'Password',
    sign_in: 'Log in',
    invite_text: 'Not yet a Stonebox client? Visit our platform and have access to our entire stock of blocks',
    btn_invite: 'Join Now',   
}